import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

const CookieConsent = () => {
  const { t } = useTranslation("cookie-consent");
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookieConsent");
    if (!consent) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookieConsent", "accepted");
    setIsVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem("cookieConsent", "declined");
    setIsVisible(false);
  };

  return (
    isVisible && (
      <div className="fixed bottom-0 left-0 w-full bg-white border-t border-gray-300 shadow-lg z-50">
        <div className="max-w-screen-lg mx-auto px-4 py-3 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-700 text-sm mb-2 md:mb-0">
            {t("cookieMessage")}{" "}
            <a
              href="/privacy"
              className="text-blue-500 hover:underline font-medium"
            >
              {t("privacyPolicy")}
            </a>.
          </p>
          <div className="flex space-x-3">
            <button
              onClick={handleDecline}
              className="bg-gray-200 hover:bg-gray-300 text-gray-700 font-medium py-2 px-4 rounded-lg"
            >
              {t("declineButton")}
            </button>
            <button
              onClick={handleAccept}
              className="bg-blue-500 hover:bg-blue-600 text-white font-medium py-2 px-4 rounded-lg"
            >
              {t("acceptButton")}
            </button>
          </div>
        </div>
      </div>
    )
  );
};

export default CookieConsent;
